/*
 * Tracking Support Script
 * =======================
 * Aids in tracking web statistics and other anonymous user data
 */
define(['c21', 'jquery'], function (c21, $) {
   "use strict";

   var self;

   function getServerName (strValue) {
      var strServerName;
      var iParmLocation;

      strServerName = strValue.toLowerCase();

      iParmLocation = strServerName.indexOf("?");
      if (iParmLocation >= 0) {
         strServerName = strServerName.substring(0, iParmLocation);
      }
      if (strServerName.indexOf("http") === 0) {
         iParmLocation = strServerName.indexOf("https://");
         if (iParmLocation >= 0) {
            strServerName = strServerName.substring((iParmLocation + 8), strServerName.length);
         }
         iParmLocation = strServerName.indexOf("http://");
         if (iParmLocation >= 0) {
            strServerName = strServerName.substring((iParmLocation + 7), strServerName.length);
         }
         iParmLocation = strServerName.indexOf("/");
         if (iParmLocation >= 0) {
            strServerName = strServerName.substring(0, iParmLocation);
         }
      } else {
         strServerName = "";
      }

      return strServerName;
   }

   function isValidC21Server (strServerName) {
      var CurrentServer = document.location.host.toLowerCase();

      if (strServerName.indexOf(".c21.com") >= 0) {
         return true;
      }
      if (strServerName === "c21.com") {
         return true;
      }
      if (strServerName.indexOf(".century21.com") >= 0) {
         return true;
      }
      if (strServerName === "century21.com") {
         return true;
      }
      if (strServerName.indexOf(".netmovein.com") >= 0) {
         return true;
      }
      if (strServerName.indexOf(".century21mortgage.com") >= 0) {
         return false; // in case they change their mind
      }
      if (strServerName === CurrentServer) {
         return true;
      }

      return false;
   }

   function gaEventTrack (sCategory, sAction, sLabel, sValue) {
      if (window.disableGATracking === true) {
         return;
      }

      // IDX Tracking
      if($('body').hasClass('pageEcoIdx')) {
         sAction = 'IDX ' + sAction;
      }

      // Note: GA (UA) is deprecated. Migrated to GA4.

      // if(window.ga) {
      //    //This 4th Parameter must be an Integer by GA Standards
      //    var hasValue = false;
      //    if ((sValue !== null && sValue !== "") || (sValue === 0)) {
      //       var intRegex = /^\d+$/;
      //       if (!isNaN(sValue) && intRegex.test(sValue)) {
      //          hasValue = true;
      //       }
      //    }
      //
      //    if(hasValue) {
      //       window.ga('send', 'event', sCategory, sAction, sLabel, sValue);
      //    } else {
      //       window.ga('send', 'event', sCategory, sAction, sLabel);
      //    }
      //
      //    var googleID = $("#googleTrackID").val();
      //    if (googleID !== null && googleID !== '') {
      //       if(hasValue) {
      //          window.ga('customTracker.send', 'event', sCategory, sAction, sLabel, sValue);
      //       } else {
      //          window.ga('customTracker.send', 'event', sCategory, sAction, sLabel);
      //       }
      //    }
      // }
   }

   function gaPageTrack (tracker, title) {
      if (window.disableGATracking === true) {
         return;
      }

      //console.log("Page tracker: ["+tracker+"]");

      // Note: GA (UA) is deprecated. Migrated to GA4.

      // if(window.ga) {
      //    if (title) {
      //       window.ga('send', 'pageview', {
      //          page: tracker,
      //          title: title
      //       });
      //    } else {
      //       window.ga('send', 'pageview', tracker);
      //    }
      //    var googleID = $("#googleTrackID").val();
      //    if (googleID !== null && googleID !== '') {
      //       if (title) {
      //          window.ga('customTracker.send', 'pageview', {
      //             page: tracker,
      //             title: title
      //          });
      //       } else {
      //          window.ga('customTracker.send', 'pageview', tracker);
      //       }
      //    }
      // }
   }

   /**
    * Adds onClick event to all href's that direct off site
    */
   function initOffsiteLinks () {
      if (window.disableGATracking === true) {
         return;
      }

      $(document).one('mouseover touchstart', 'a', function () {
         var jAnchor = $(this);
         var strHref = jAnchor.attr('href');

         if (!strHref) {
            return;
         }

         var strServerName = getServerName(strHref);

         if (!strServerName) {
            return;
         }

         if (isValidC21Server(strServerName)) {
            return;
         }

         var strNewTitle = 'You have selected a link to a website that is not owned or maintained by Century21.com.  Different terms of use and privacy policies will apply.';

         var strOriginalLinkTitle = jAnchor.attr('title');
         if (strOriginalLinkTitle) {
            strNewTitle += ' ' + strOriginalLinkTitle;
         }

         jAnchor.attr({
            title: strNewTitle,
            target: '_BLANK'
         });
      });
   }

   self = {
      initOffsiteLinks: initOffsiteLinks,

      c21Reporting: function (strWhat, strType, strKey) {
         if (window.disableGATracking === true) {
            return;
         }
         if (strKey.charAt(0) >= 'A' && strKey.charAt(0) <= 'Z') {
            return;
         }
         var pIframe = document.getElementById('messagequeueiframe');
         if (pIframe) {
            var strRndId = (Math.random() * 10000000000000).toString();
            pIframe.src = '/reporting/' + strWhat + '?id=' + strKey + '&type=' + strType + '&rnd=' + strRndId;
         }
         return true;
      },

      doEvent: function (sCategory, sAction, sLabel, sValue) {
         if (window.disableGATracking === true) {
            return;
         }

         gaEventTrack(sCategory, sAction, sLabel, sValue);
         //c21.stopEvent();
      },

      doEventByPropTypeLabel: function (sCategory, sAction, brandCd) {
         var sLabel = "";
         if (brandCd !== null && brandCd !== "" && brandCd !== "undefined") {
            if (brandCd === 'REN' || brandCd === 'C21') {
               sLabel = brandCd;
            } else {
               sLabel = 'sister';
            }
         }
         if (sLabel !== "") {
            self.doEvent(sCategory, sAction, sLabel);
         } else {
            self.doEvent(sCategory, sAction);
         }
      },

      doTracking: function (tracker) {
         if (window.disableGATracking === true) {
            return;
         }
         gaPageTrack('/conversions/' + tracker);
      },

      doPageTrack: function(url, title) {
         if (window.disableGATracking === true) {
            return;
         }
         if (!url) {
            url = document.location.pathname;
            title = $('title').text();
         }
         gaPageTrack(url, title);
      }

   };

   // For anchors with inline JS only
   window.Track = self;
   initOffsiteLinks();

   return self;
});
